import {
    API_ENDPOINTS,
    GenericObjectInterface,
    headersList,
    makeApiRequest,
} from "@/src/utilities";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const fetchWhitepapers = createAsyncThunk<GenericObjectInterface>(
    "gated/whitepapers",
    async (_, { rejectWithValue, getState }) => {
        const state: any = getState();

        const { userStateReducer } = state;
        try {
            const headerList = {
                ...headersList,
                // Authorization: `Token ${userStateReducer?.token}`,
            };
            const response = await makeApiRequest<GenericObjectInterface>(
                "get",
                API_ENDPOINTS.WHITEPAPERS,
                null,
                headerList
            );

            return response;
        } catch (error) {
            console.error(error);
            return rejectWithValue("Please try again later!");
        }
    }
);